module.exports = __webpack_public_path__ + "img/phone1.76d5095c.png";